import i18next from 'i18next';
import HttpBackend from 'i18next-http-backend';
import ICU from 'i18next-icu';
import { initReactI18next, useTranslation as useReactI18nextTranslation } from 'react-i18next';
import { createLocaleProxy } from 'anchor-i18n';
import { DEFAULT_LOCALE, readLocaleCookie, SUPPORTED_LOCALES } from './locales';
const initialLanguage = readLocaleCookie(document.cookie);
export const buildLocaleLoadPath = (staticFilesPath)=>"".concat(staticFilesPath !== null && staticFilesPath !== void 0 ? staticFilesPath : '', "/locales/{{lng}}.json");
if (process.env.NODE_ENV === 'development') {
    // Development and test mode: Load the active language synchronously (no HTTP, no Suspense needed).
    // Always also load the fallback locale so missing keys fall back to English instead of
    // rendering the literal key path.
    const activeTranslations = require("anchor-i18n/dist/frontend/".concat(initialLanguage, ".json"));
    const resources = initialLanguage === DEFAULT_LOCALE ? {
        [DEFAULT_LOCALE]: {
            translation: activeTranslations
        }
    } : {
        [initialLanguage]: {
            translation: activeTranslations
        },
        [DEFAULT_LOCALE]: {
            translation: require("anchor-i18n/dist/frontend/".concat(DEFAULT_LOCALE, ".json"))
        }
    };
    i18next.use(ICU).use(initReactI18next).init({
        lng: initialLanguage,
        fallbackLng: DEFAULT_LOCALE,
        supportedLngs: [
            ...SUPPORTED_LOCALES
        ],
        resources,
        initImmediate: false,
        interpolation: {
            escapeValue: false
        },
        react: {
            useSuspense: false
        }
    });
} else {
    // Production: Lazy-load translations via HTTP
    // App is wrapped in Suspense to wait for translations before rendering
    i18next.use(HttpBackend).use(ICU).use(initReactI18next).init({
        lng: initialLanguage,
        fallbackLng: DEFAULT_LOCALE,
        supportedLngs: [
            ...SUPPORTED_LOCALES
        ],
        backend: {
            loadPath: buildLocaleLoadPath(window._staticFilesPath)
        },
        interpolation: {
            escapeValue: false
        },
        // Enable Suspense - app waits for translations before rendering
        react: {
            useSuspense: true
        }
    });
}
export function useLocaleKeys(path) {
    const { i18n, ready } = useReactI18nextTranslation();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const tFn = i18n.t.bind(i18n);
    const fullT = createLocaleProxy(tFn);
    const getNestedValue = (obj, pathStr)=>{
        return pathStr.split('.').reduce((acc, key)=>acc === null || acc === void 0 ? void 0 : acc[key], obj);
    };
    return {
        t: path ? getNestedValue(fullT, path) : fullT,
        i18n,
        ready
    };
}
export default i18next;
